import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";

const ProductCards = ({ productsProfile }) => {
  return (
    <div className="">
      <section className="text-gray-600 mb-10 body-font">
        <div className="flex flex-col text-center w-full mt-5 mb-5">
          <h1 className="text-sm title-font font-semibold text-gray-500">
            SPONSORED
          </h1>
        </div>
        <Swiper
          slidesPerView={5}
          spaceBetween={20}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
          modules={[Autoplay, Pagination]}
          className="mySwiper"
        >
          {productsProfile.map((spo, index) => (
            <SwiperSlide key={index} className="mb-10">
              <div className="flex flex-col items-center h-60 justify-center border border-gray-300 p-4">
                <img
                  src={spo.ProfilePicture}
                  alt="Extra large avatar"
                  className="rounded-full shadow-lg w-34 h-34 border-2 border-gray-900"
                  style={{ width: "150px", height: "150px" }}
                
                />
                <h2 className="text-md font-semibold text-center mt-5 text-gray-900">
                  {spo.Name}
                </h2>
                <p className="text-sm text-center">
                  {spo.ProfessionPositionName}
                </p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
    </div>
  );
};

export default ProductCards;
